//@flow
import styled from 'styled-components';

export const PillContainer = styled.div`
  margin-bottom: 20px;
`;

export const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-x: auto;
  justify-content: space-between;

  &::-webkit-scrollbar {
    height: 0;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }
`;
